// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import vuex from 'vuex'
import store from './store'
import api from './api/index'
import util from './util/index'

Vue.use(ElementUI)
Vue.use(vuex)

Vue.config.productionTip = false

// router.beforeEach((to, from, next) => {
//   if (to.path === '/myvue') {
//     next({path: '/he'})
//   } else {
//     next()
//   }
// })
Vue.prototype.$api = api
Vue.prototype.$util = util

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js